import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Checkmark } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../Icon';
import Flex from '../Flex';
import system from '../../system';
import styles from './index.module.css';
import ChoiceInfo from './ChoiceInfo';
import ChoiceTitle from './ChoiceTitle';
import ChoiceBody from './ChoiceBody';
import ChoiceMessage from './ChoiceMessage';
import ChoiceImage from './ChoiceImage';
const SYSTEM_PROPS = ['marginProps', 'floatProps'];
const Choice = /*#__PURE__*/function () {
  const Choice = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      message,
      children,
      disabled,
      id,
      imageAlt,
      imageSrc,
      info,
      labelProps,
      name,
      title,
      type,
      value,
      onFocus,
      onBlur,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    return /*#__PURE__*/React.createElement("label", _extends({
      className: cx(className, styles.root),
      style: style,
      htmlFor: id
    }, labelProps), /*#__PURE__*/React.createElement("input", _extends({}, rest, {
      className: styles.input,
      disabled: disabled,
      id: id,
      name: name,
      type: type,
      value: value,
      ref: ref,
      onFocus: onFocus,
      onBlur: onBlur
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement("div", {
      className: cx({
        [styles.iconContainer]: true,
        [styles.checkboxContainer]: type === 'checkbox',
        [styles.radioContainer]: type === 'radio'
      })
    }, type === 'checkbox' && /*#__PURE__*/React.createElement(Icon, {
      className: styles.icon,
      as: Checkmark,
      size: "small"
    })), /*#__PURE__*/React.createElement("header", {
      className: styles.header
    }, !!imageSrc && /*#__PURE__*/React.createElement(ChoiceImage, {
      src: imageSrc,
      alt: imageAlt
    }), /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "center",
      flexDirection: "column"
    }, info && /*#__PURE__*/React.createElement(ChoiceInfo, null, info), /*#__PURE__*/React.createElement(ChoiceTitle, null, title), message && /*#__PURE__*/React.createElement(ChoiceMessage, null, message))), children && /*#__PURE__*/React.createElement(ChoiceBody, null, children)));
  });
  Choice.displayName = 'Choice';
  Choice.identifier = Choice.displayName;
  Choice.clonableProps = SYSTEM_PROPS;
  Choice.defaultProps = {
    type: 'radio'
  };
  return Choice;
}();
export default Choice;